import React from 'react';

const HeartIcon = ({ 
  filled = false, 
  size = 30, 
  color = 'currentColor',
  className = '',
  style = {}
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={filled ? color : 'none'}
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`heart-icon ${className}`}
      style={{ ...style,
      filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.5))'
      }}
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
};

export default HeartIcon;
